import React, { Component, Fragment } from 'react';
import card_picture from '../images/card-picture.png';
import '../styles/Payment.scss';
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import loader from '../images/loader.gif';
import { withTranslation } from 'react-i18next';
import { createNewUserPoolForTenantAfterPurchase } from '../services/tenant-identity-service';

class Payment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isConfirmModalOpen: false,
            isLoading: false,
            alert_type: '',
            alert_message: ''
        };

        console.log('langaueg state++++++++', this.state);
    }

    clearAlertType = () => {
        setTimeout(() => {
            this.setState({ alert_type: '' });
        }, 4000);
    }

    handleConfirmModalClose = event => {
        this.setState({ isConfirmModalOpen: false });
    }

    handleConfirmModalOpen = async (event, item) => {
        await this.setState({ isConfirmModalOpen: true });
        await this.setState({ selectedLanguageObj: item });
    }

    handleSubmit = (e) => {
        try {
            e.preventDefault();
            this.clearAlertType();
            let tenantResult = this.props.auth.tenantResult;
            let tenantUserGuid = this.props.auth.tenantUserGuid;
            this.setState({ isLoading: true });
            let inputData = {
                "tenantGuid": tenantResult.tenantGuid,
                "userGuid": tenantUserGuid
            }

            if (tenantResult.isPurchase === false) {
                createNewUserPoolForTenantAfterPurchase(inputData).then(async (response) => {
                    this.props.history.push('/Success');
                    localStorage.setItem('isTenantPurchased', 1);
                }).catch(err => {
                    console.log('createNewPoolAfterPurchaeUrl error', err);
                    this.setState({ isLoading: false });

                    let finalMessage = err.response.data.message;
                    this.setState({ alert_type: 'ERROR' })
                    this.setState({ alert_message: finalMessage })
                });
            } else {
                this.props.history.push('/Success');
            }
        } catch (err) {
            console.log('error', err.response);
            this.setState({ isLoading: false });

            let finalMessage = err.response.data.message;
            this.setState({ alert_type: 'ERROR' })
            this.setState({ alert_message: finalMessage })
        }

    }

    radioBtnOnChanged = (e) => {
    }

    render() {
        const { t } = this.props;
        return (
            <main className="Dash-board">
                <div className="Dash-board-div">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <SideBar {...this.props} />
                            </div>

                            <Fragment>
                                <div className="col-md-9">
                                    <Header {...this.props} />
                                    <div className="payment-content-sec">
                                        <div className="Payment-sec">
                                            <div className="payment-text">
                                                <h4>{t('Payment')}</h4>
                                                <p className="msg-content">* {t('Please do not refresh the page until payment is completed')}.</p>
                                            </div>
                                            <p className="amount-payable">{t('Amount Payable')} <span>$ 0</span>/{t('month')}</p>

                                            <form action="">
                                                <div className="radio-btns">
                                                    <div className="radio-item">
                                                        <input type="radio" name="optradio" checked={true} onChange={this.radioBtnOnChanged} /> <label>{t('Credit')} / {t('Debit')}
                                                            {t('Card')}</label>
                                                    </div>
                                                    <div className="radio-item">
                                                        <input type="radio" name="optradio" /> <label>{t('Net Banking')}</label>
                                                    </div>
                                                    <div className="radio-item">
                                                        <input type="radio" name="optradio" /> <label>{t('UPI')} / {t('Wallets')}</label>
                                                    </div>
                                                </div>
                                                <div className="details">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <label htmlFor="cc-number">{t('Card Number')}</label>
                                                            <div className="flex-wrap">
                                                                <div className="margin-bottom-16">
                                                                    <input type="text" className="form-control" id="cc-number"
                                                                        placeholder="xxxx - xxxx - xxxx - xxxx" required />
                                                                </div>
                                                                <div className="margin-bottom-16">
                                                                    <img src={card_picture} alt="" style={{ height: "40px" }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 margin-bottom-16">
                                                            <label htmlFor="cc-name">{t('Name on Card')}</label>
                                                            <input type="text" className="form-control" id="cc-name" placeholder=""
                                                                required />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 flex-wrap">
                                                            <div className="expiry">
                                                                <label htmlFor="cc-expiration">{t('Expiry Date')}</label>
                                                                <div className="flex-wrap">
                                                                    <select name="" className="form-control date" id="">
                                                                        <option value="">MM</option>
                                                                    </select>
                                                                    <select name="" className="form-control year" id="">
                                                                        <option value="">YYYY</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="cvv-sec">
                                                                <label htmlFor="cc-cvv">{t('CVV')}</label>
                                                                <input type="text" className="form-control cvv-code" id="cc-cvv"
                                                                    placeholder="" />
                                                            </div>
                                                            <div className="cvv-text">
                                                                {/* <p>* Lorem ipsum dolor sit amet Proin dictum sapien eu.</p> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div onClick={this.handleSubmit} className="btn btn-primary demo-btn" type="submit">{t('PAY')} 0</div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>

                            {
                                (this.state.isLoading) ? (
                                    <img src={loader} alt="" className="loader" />
                                ) : null
                            }
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>

        )
    }
}
export default withTranslation()(Payment)